/**
 * Icono y color fijos por métrica (spec 009-dashboard-camino, FR-002)
 *
 * La misma métrica lleva el mismo icono y color en toda la página.
 */

import { Eye, Euro, Film, Printer, Repeat, Star, UserPlus, Users } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type MetricKey =
  | 'tickets'
  | 'memories'
  | 'views'
  | 'reviews'
  | 'returning'
  | 'euros'
  | 'new_clients'
  | 'clients';

interface MetricStyle {
  icon: LucideIcon;
  circle: string;
  color: string;
}

export const METRIC_ICONS: Record<MetricKey, MetricStyle> = {
  tickets: { icon: Printer, circle: 'bg-gray-100', color: 'text-gray-700' },
  memories: { icon: Film, circle: 'bg-indigo-50', color: 'text-indigo-600' },
  views: { icon: Eye, circle: 'bg-cyan-50', color: 'text-cyan-700' },
  reviews: { icon: Star, circle: 'bg-amber-50', color: 'text-amber-700' },
  returning: { icon: Repeat, circle: 'bg-violet-50', color: 'text-violet-600' },
  euros: { icon: Euro, circle: 'bg-[#b41f3d]', color: 'text-white' },
  new_clients: { icon: UserPlus, circle: 'bg-green-50', color: 'text-green-700' },
  clients: { icon: Users, circle: 'bg-blue-50', color: 'text-blue-600' },
};
